import { render, staticRenderFns } from "./AddressCreateUpdate.vue?vue&type=template&id=f8e2973e&"
import script from "./AddressCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./AddressCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports